import { useEffect, useLayoutEffect, useRef } from "react";
import ReactQuill from "react-quill";
import { message } from "antd";
import { upload } from "@/api";
import { bindDetailImageUpload } from "@/utils/goodsDescription";
import styles from "./ProductDialog.module.css";

export async function uploadGoodsDescriptionImage(file: File): Promise<string> {
  const result = await upload(file);
  if (typeof result.data !== "string") throw new Error("上传未返回图片地址");
  return result.data.trim();
}

const modules = { toolbar: [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ color: [] }],
  [{ background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image"],
] };

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  disabled: boolean;
  onBusyChange: (busy: boolean) => void;
}

export function GoodsDescriptionEditor({ value, onChange, disabled, onBusyChange }: Props): React.ReactElement {
  const editor = useRef<ReactQuill>(null);
  const busyHandler = useRef(onBusyChange);
  useLayoutEffect(() => { busyHandler.current = onBusyChange; }, [onBusyChange]);
  useEffect(() => {
    const quill = editor.current?.getEditor();
    if (!quill) return;
    return bindDetailImageUpload(quill, uploadGoodsDescriptionImage,
      (busy) => busyHandler.current(busy),
      (error) => { void message.error(error); });
  }, []);
  return <ReactQuill ref={editor} value={value ?? ""} onChange={onChange}
    modules={modules} readOnly={disabled} className={styles.descriptionEditor}
    placeholder="填写商品介绍，图片上传后直接显示；单张不超过 10 MB" />;
}
